import { api } from "./api";

export type Brand = {
  title: string;
  backgroundImageUrl: string;
  smallLogoUrl: string;
};

export type Hero = {
  heading1: string;
  heading2: string;
  body1: string;
};

export type Product = {
  id: string;
  name: string;
  price: number;
  abv: number;
  description: string;
  imageMasterUrl: string;
  images: string[];
  showBuyButton: boolean;
  ibu?: number;
};

export type HomePageData = {
  brand: Brand;
  hero: Hero;
  products: Product[];
};

export const fetchHomepageData = async () => {
  try {
    const response = await api.get("home");
    return response.data.data as HomePageData;
  } catch (error: any) {
    console.error(
      "Error fetching products:",
      error.response?.data || error.message
    );
  }
};
